import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Portal } from 'react-portal'
import { history } from 'utils/history'
import { IS_BROWSER } from 'constants/environment'
import { withRadium, DetectCompact, SearchParams } from 'higher-order-components'
import { ExpandableInfo, ServiceCalculatorFilter, ServiceDetails, HeadingBlock } from 'containers'
import exposeGlobal from 'apis/expose-global'
import { Button } from 'components'
import close from './close.svg'
import spinnerSvg from './spinner.svg'
import { Section } from "AtomicComponents"

class ServiceCalculatorProspect extends Component {
  static propTypes = {
    data: PropTypes.object,
    endpoint: PropTypes.string,
    name: PropTypes.string,
    termsAndConditions: PropTypes.string,
    search: PropTypes.obj,
    compact: PropTypes.bool
  }
  static defaultProps = {
    endpoint: '/api/prospectserviceschedule?modelCode=',
    description:
      'Take the guesswork out of service pricing. Use the service schedule guide below to view current service details and pricing'
  }
  constructor(props) {
    super(props)
    this.state = {
      displaySpinner: false,
      serviceItems: null,
      selection: null,
      prevSelection: null,
      isUpdatingFilters: false
    }

    this.handleFilterSubmit = (serviceCode, selection) => {
      this.fetchService(serviceCode, selection)
    }

    // If user click on "Edit Selection" button, reset the state of the component
    this.handleEditSelection = () => {
      this.setState({
        displaySpinner: false,
        serviceItems: null,
        selection: null,
        prevSelection: null,
        isUpdatingFilters: true
      })
    }

    this.cancelFilterEdit = () => {
      this.setState({ isUpdatingFilters: false })
    }

    this.fetchService = (modelCode, selection) => {
      this.setState({
        selection,
        prevSelection: selection,
        displaySpinner: true,
        isUpdatingFilters: false
      })
      const url = `${this.props.endpoint}${modelCode}`
      const options = {
        method: 'GET',
        headers: {
          'content-type': 'application/json'
        }
      }

      fetch(url, options)
        .then((response) => {
          if (response.status !== 200) {
            throw new Error(`Unfortunately the service is unavailable. Please try again later (Status ${response.status}).`)
          }
          return response.json()
        })
        .then((json) => {
          if (json.errorCode || json.errorCode === 0) {
            throw new Error(`Failed with errorCode ${json.errorCode}`)
          } else if (json.errorMessage) {
            throw new Error(`Failed with errorMessage ${json.errorMessage}`)
          }

          return json
        })
        .then((allServiceItems) => {
          // Only get the first five 'Scheduled Maintenance' and first two 'Additional Scheduled Maintenance' items
          const displayItems = []
          let smCount = 0
          let asmCount = 0
          allServiceItems.serviceItems.forEach((item, index) => {
            if (item.factoryCodeEntity.type === 'Scheduled Maintenance') {
              smCount += 1
              if (smCount < 6) {
                displayItems.push(item)
              }
            } else {
              asmCount += 1
              if (asmCount < 3) displayItems.push(item)
            }
          })
          allServiceItems.serviceItems = displayItems
          this.setState({
            serviceItems: allServiceItems,
            displaySpinner: false
          })
        })
        .catch((error) => {
          this.setState({ displaySpinner: false })
          console.warn(`URL: ${url}`, error)
        })
    }
  }
  componentDidMount() {
    if (!IS_BROWSER) return
    exposeGlobal('getCurrentFormFields', () => this.state.currentSelection)
    const readUrl = (url) => {
      const search = new window.URL(url.pathname + url.search, window.location).searchParams
      const model = search.get('model')
      const body = search.get('body')
      const grade = search.get('grade')
      const engine = search.get('engine')
      const newSelection = [model, body, grade, engine]
      if (search || model || body || grade || engine) {
        this.setState(
          {
            isUpdatingFilters: !!this.state.prevSelection,
            currentSelection: newSelection,
            prevSelection: this.state.selection
          },
          () => {
            const selection = this.filterComponent.getSelection()
            const newModelCode = selection.modelCode
            if (newModelCode) {
              this.fetchService(selection.modelCode, selection.selection)
            }
          }
        )
      }
    }
    readUrl(window.location)
    this.unlistenHistory = history.listen((url) => {
      readUrl(url)
    })
  }

  componentWillUnmount() {
    this.unlistenHistory()
  }

  pushUrl() {
    if (!this.state.currentSelection || !IS_BROWSER) return
    this.props.search.pushParam({
      model: this.state.currentSelection[0],
      body: this.state.currentSelection[1],
      grade: this.state.currentSelection[2],
      engine: this.state.currentSelection[3],
      modelCode: this.state.currentSelection[4]
    })
  }
  renderMainFilter() {
    return (
      <ServiceCalculatorFilter
        ref={(comp) => {
          this.filterComponent = comp
        }}
        key="serviceCalcFilterMain"
        vehiclesData={this.props.data}
        onSubmit={this.handleFilterSubmit}
        ctaLabel={this.state.isUpdatingFilters ? 'Update' : 'Submit'}
        selection={this.state.currentSelection}
        onChange={(modelCode, selection) => {
          this.setState(
            {
              modelCode,
              currentSelection: selection
            },
            () => this.pushUrl()
          )
        }} />
    )
  }
  renderFilter(compact) {
    return compact ? (
      <div>
        {this.renderMainFilter()}
        {this.state.isUpdatingFilters && (
          <Portal key="serviceCalcFilterEdit">
            <div style={styles.popup}>
              <div style={styles.popupCloseButton} onClick={this.cancelFilterEdit} />
              <HeadingBlock value={'Not part of the family yet?'} textAlign="center" />
              <HeadingBlock
                tag="h6"
                textAlign="center"
                value="Update your selection to get a new set of servicing costs" />
              <ServiceCalculatorFilter
                vehiclesData={this.props.data}
                onSubmit={this.handleFilterSubmit}
                selection={this.state.prevSelection}
                ctaLabel="Update" />
            </div>
          </Portal>
        )}
      </div>
    ) : (
      <div style={styles.filterContainerLarge}>{this.renderMainFilter()}</div>
    )
  }
  render() {
    const { compact } = this.props
    const {
      selection, displaySpinner, serviceItems, isUpdatingFilters
    } = this.state

    return (
      <div>
        <Section padding backgroundColor="#f5f5f5">
          <div>
            <HeadingBlock
              tag="h4"
              margin={false}
              value={
                selection
                  ? 'Your service summary'
                  : this.props.name ? this.props.name : 'Mazda service calculator'
              }
              textAlign="center" />
            {selection ? (
              <div style={styles.textCenter}>
                <div style={{ lineHeight: 2 }}>
                  <b>Currently viewing:</b> {selection.join(' ')}
                </div>
                <p style={{ lineHeight: 1.8 }}>
                  The total service price is the Base Scheduled Maintenance, plus any Additional
                  Scheduled Maintenance items that are required.
                </p>
              </div>
            ) : (
              <div style={styles.textCenter}>{this.props.description}</div>
            )}
            {(isUpdatingFilters || !selection) && this.renderFilter(compact)}
            {selection &&
              !isUpdatingFilters && (
                <div style={styles.ctaButton}>
                  <Button
                    styleName="black"
                    label="Edit selection"
                    onClick={this.handleEditSelection}
                    disabled={displaySpinner} />
                </div>
              )}
            {displaySpinner && (
              <div style={styles.spinnerContainer}>
                <img src={spinnerSvg} style={styles.spinnerGraphic} />
              </div>
            )}
          </div>
        </Section>
        {serviceItems &&
          !isUpdatingFilters && (
            <Section padding backgroundColor="#ffffff">
              <ServiceDetails data={this.state.serviceItems} />
              <div style={{ backgroundColor: 'white', paddingTop: '2em' }}>
                <div style={{ maxWidth: '70em', margin: 'auto' }}>
                  <ExpandableInfo
                    color="#cccccc"
                    mainText="Read full terms and conditions"
                    description={this.props.termsAndConditions} />
                </div>
              </div>
            </Section>
          )}
      </div>
    )
  }
}

export default withRadium(DetectCompact(), SearchParams())(ServiceCalculatorProspect)

const styles = {
  textCenter: {
    paddingTop: '1.2em',
    textAlign: 'center',
    fontWeight: 200
  },
  filterContainerLarge: {
    transition: 'max-height 1s cubic-bezier(0.99, 0.03, 1, 1)',
    maxHeight: '1000px',
    display: 'block'
  },
  ctaButton: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '1em'
  },
  popup: {
    position: 'fixed',
    boxSizing: 'border-box',
    left: '0px',
    right: '0px',
    bottom: '0px',
    top: '0px',
    padding: '2em',
    backgroundColor: '#e5e6e9',
    zIndex: '100',
    overflow: 'auto'
  },
  popupCloseButton: {
    width: '100%',
    height: '2em',
    padding: '0em',
    backgroundImage: `url(${close})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center right',
    cursor: 'pointer',
    ':hover': {
      opacity: '.5'
    }
  },
  spinnerContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '1em'
  },
  spinnerGraphic: {
    width: '5vw',
    height: '5vw',
    margin: '5em'
  }
}



// WEBPACK FOOTER //
// ./src/containers/service-calculator-prospect/index.jsx